import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource-variable/geist';
import '@fontsource-variable/inter';
import '@fontsource-variable/fraunces';
import './App.css';
import App from './App';
import { bootPrefetch } from '@/lib/route-preload';
import { installNumberLocale } from '@/lib/number-locale';

// Counts group digits the way the workspace's money does (lib/number-locale).
installNumberLocale();

// Start the page's code and data before React renders (lib/route-preload).
bootPrefetch();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
